import * as nodeUtils from "../../../abstract/controller/utils/nodeUtils";
import * as systemUtils from "../../../abstract/controller/utils/systemUtils";
import { DeveloperBoard24Regular } from "../../../themes/icons/DeveloperBoard24Regular";
import { OutlineAccountTree } from "../../../themes/icons/OutlineAccountTree";
import Aside from "./Aside";
import AsideElementDev from "./AsideElementDev";
import AsideElementOverview from "./AsideElementOverview";
import styles from "./AsideLeft.module.scss";
import AsideLeftControllerIcon from "./AsideLeftControllerIcon";

function AsideLeft({
  showAside,
  setShowAside,
  nodeFunction,
  showGlobals,
  setShowGlobals,
  showFunction,
  setShowFunction,
  showConditions,
  setShowConditions,
}) {
  const isDev = systemUtils.isEnvDev();

  const _nameFunction = nodeUtils.getName(nodeFunction);
  const _icons = isDev
    ? [<OutlineAccountTree />, <DeveloperBoard24Regular />]
    : [<OutlineAccountTree />];

  const handleChange = (id) => {
    if (showAside === -1) {
      setShowAside(id);
    } else if (showAside === id) {
      setShowAside(-1);
    } else {
      setShowAside(id);
    }
  };

  return (
    <div className={styles["aside"]}>
      <div className={styles["aside__max"]}>
        <Aside showAside={showAside !== -1} primary>
          {showAside === 0 && (
            <AsideElementOverview
              showGlobals={showGlobals}
              setShowGlobals={setShowGlobals}
              nameFunction={_nameFunction}
              showFunction={showFunction}
              setShowFunction={setShowFunction}
              showConditions={showConditions}
              setShowConditions={setShowConditions}
            />
          )}
          {showAside === 1 && <AsideElementDev />}
        </Aside>
      </div>
      <div className={styles["aside__min"]}>
        {/* <AsideController showAside={showAside} setShowAside={setShowAside} primary/> */}
        <AsideLeftControllerIcon display={showAside} onChange={handleChange} icons={_icons} />
      </div>
    </div>
  );
}

export default AsideLeft;
